'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/PrintButtonsToolbar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PrintButtonsToolbar(_ref) {
  var children = _ref.children,
      numItemsToPrint = _ref.numItemsToPrint;

  return _react2.default.createElement(
    'div',
    { className: 'cp-print-buttons-toolbar' },
    _react2.default.createElement(
      _baseButtons.PrimaryButton,
      { className: 'btn-sm', handleClick: function handleClick() {
          return window.print();
        } },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'print_items',
        values: {
          num_items: numItemsToPrint
        } })
    ),
    children,
    _react2.default.createElement(
      _baseButtons.PrimaryButton,
      { className: 'btn-sm', handleClick: function handleClick() {
          return window.close();
        } },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
    )
  );
}

PrintButtonsToolbar.propTypes = {
  numItemsToPrint: _react.PropTypes.number.isRequired,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
};

exports.default = PrintButtonsToolbar;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/print/lib/components/print-buttons-toolbar/components/PrintButtonsToolbar.component.js
// module id = 1446
// module chunks = 1